

























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BasicList extends Vue {
  @Prop(Array) readonly items!: Array<any>
  @Prop(String) readonly itemKey!: string
  @Prop(String) readonly itemTitle!: string
  @Prop(Boolean) readonly editable!: boolean
  @Prop(Boolean) readonly deletable!: boolean
}
